import Dialog from '@mui/material/Dialog';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetLinkedIn } from '../../../hooks/useTalent';
// import { ROUTES } from '../../../consts'; //TODO need to think if its good solution
import { createEmptyTalentObject } from '../../TalentsPage/utils';
import STRING_KEYS from '../../../language/keys';
import NewTalentDialogActions from './NewTalentDialogActions';
import NewTalentDialogHeader from './NewTalentDialogHeader';
import NewTalentDialogContent from './NewTalentDialogContent';

type NewTalentDialogProps = {
    onTalentReady: (data: FormattedTalentResponse) => void
    isShowDialog: boolean,
  }

export default function NewTalentDialog({
  isShowDialog,
  onTalentReady,
}:NewTalentDialogProps):JSX.Element {
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [isPrivateProfile, setPrivateProfile] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const getTalent = useGetLinkedIn((data: FormattedTalentResponse) => {
    onTalentReady({
      ...data,
      linkedinUrl,

      // backend requested to move linkedin-profile-image (from server's response) into the temp-image property.
      // it will be more logical that this will happen on server side,
      // but we're always happy to help :)
      profileImageTempUrl: data.profileImage,
      profileImage: '',
    });
  }, () => {
    setPrivateProfile(true);
  }, (message:string) => {
    setErrorMessage(message || translate(STRING_KEYS.GENERAL_SERVER_ERROR));
  });

  const cancelHandler = () => {
    // navigate(ROUTES.TALENTS); //TODO need to think if its good solution onBack implementation
    navigate(-1);
  };

  const continueHandler = () => {
    getTalent.mutate(linkedinUrl);
  };

  const onLinkedInValueChanged = (e:React.ChangeEvent<HTMLInputElement>) => {
    getTalent.reset();
    setLinkedinUrl(e.target.value);
    setPrivateProfile(false);
  };

  return (
    <Dialog open={ isShowDialog }>
      <NewTalentDialogHeader onCloseClick={ cancelHandler } />
      <NewTalentDialogContent
        error={ getTalent.isError }
        isPrivateProfile={ isPrivateProfile }
        linkedinUrl={ linkedinUrl }
        onLinkedInValueChanged={ onLinkedInValueChanged }
        onCreateTalentManually={ () => onTalentReady(createEmptyTalentObject(linkedinUrl)) }
        isLoading={ getTalent.isLoading }
        errorMessage={ errorMessage }
      />
      <NewTalentDialogActions
        onCancelClick={ cancelHandler }
        onContinueClick={ continueHandler }
        disabled={ getTalent.isError || linkedinUrl.trim() === '' || getTalent.isLoading }
      />
    </Dialog>
  );
}
